
<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.CaseSummaryExternal">
    <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
        <div appDialogDragArea cdkDragHandle></div>
        <app-case-summary-external-modal [entry]="data.entry" [caseId]="data.entry.caseId" [channelType]="data.channelType" (closed)="close()"></app-case-summary-external-modal>
      </mat-dialog-content>
</div>
